import { Live } from "@/app/entities/Live";
import { withCdn } from "@/app/utils/withCdn";
import { format } from "date-fns";
import { Radio } from "lucide-react";

import { PARTNER_LOGO } from "@/app/utils/getPartnerLogo";
import { cn } from "@/app/utils/cn";

interface ViewLiveProps {
  live: Live;
}



export function ViewLive({ live }: ViewLiveProps) {
  return (
    <aside className="flex flex-col gap-4 border-l pl-8">
      <h1 className="text-xl font-semibold">{live.title}</h1>
      <img
        src={live.thumbnail_url ? withCdn(live?.thumbnail_url) : PARTNER_LOGO}
        alt={live?.title}
        className={cn(
          "h-[214px] w-[500px] rounded-lg bg-gray-200",
          !live.thumbnail_url && "contrast-50",
        )}
      />
      <div className="flex items-center justify-center gap-2 rounded-lg  bg-[#E2B93B] py-3 text-white">
        <Radio className="h-4 w-4" />
        <p>
          Começa em:{" "}
          <strong className="font-semibold">
            {format(live?.nextDate, "dd/MM/yyyy")}
          </strong>{" "}
          as{" "}
          <strong className="font-semibold">
            {format(live?.nextDate, "HH:mm")}
          </strong>
        </p>
      </div>
      <div className="rounded-lg bg-[#F7F7F7] p-5 text-sm">
        <h3 className="mb-4 font-semibold">Sobre a aula</h3>
        <p className="whitespace-pre-wrap text-[#9F9F9F]">{live.description}</p>
      </div>
    </aside>
  );
}
